import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { EditClientModal } from '../EditClientModal';
export function useOpenEditClientModal() {
    const { showModal } = useOverlayContext();
    return useCallback((param)=>{
        let { clientId, initialName, initialClientType } = param;
        return showModal({
            biName: 'edit_client',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(EditClientModal, {
                    clientId: clientId,
                    initialName: initialName,
                    initialClientType: initialClientType,
                    dismissModal: dismissModal
                });
            }
        });
    }, []);
}
